module.exports = __webpack_public_path__ + "fonts/Hasklig-Regular.woff2";